import React, { useEffect } from 'react';
import RegistrationForm from '@/components/RegistrationForm';
import LazyImage from '@/components/LazyImage';
import ScrollIndicator from '@/components/ScrollIndicator';

const Index = () => {
  // Animation sequence on load
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-load');
    
    elements.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add('opacity-100');
        el.classList.remove('opacity-0', 'translate-y-4');
      }, 200 * index);
    });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 relative">
      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        {/* Grid layout da seção principal - Mantém o mesmo para mobile */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10">
          {/* Imagem - Agora na direita apenas no desktop */}
          <div className="flex flex-col order-1 lg:order-2">
            <div className="aspect-video rounded-lg overflow-hidden shadow-lg animate-on-load opacity-0 translate-y-4 transition-all duration-700 ease-out ring-1 ring-purple-100">
              <LazyImage 
                src="/lovable-uploads/3cc72e24-c33e-434e-9298-103358260f4c.png" 
                alt="Ano-Novo Astrológico 2025 - Aula Especial" 
                className="h-full"
              />
            </div>
            
            {/* Seção numerada - Apenas no desktop aparece ao lado da imagem, reduzindo espaço em branco */}
            <div className="hidden lg:block mt-8 animate-on-load opacity-0 translate-y-4 transition-all duration-700 delay-400 ease-out">
              <div className="text-center mb-8">
                <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-purple-800 to-indigo-700 bg-clip-text text-transparent">
                  Para quem é esse evento?
                </h2>
              </div>
              <div className="grid grid-cols-1 gap-4">
                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                      1
                    </div>
                  </div>
                  <p className="text-gray-700">Para quem quer descobrir uma visão que vai além da astrologia</p>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                      2
                    </div>
                  </div>
                  <p className="text-gray-700">Para quem está insatisfeita com a própria vida e quer mudar</p>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                      3
                    </div>
                  </div>
                  <p className="text-gray-700">Para quem quer aproveitar ao máximo esse momento de renovação de ciclo</p>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                      4
                    </div>
                  </div>
                  <p className="text-gray-700">Para quem busca uma conexão espiritual profunda e está aberto para o novo</p>
                </div>
                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                      5
                    </div>
                  </div>
                  <p className="text-gray-700">Para quem quer aprender novas práticas espirituais, rituais e novas formas de meditar</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Conteúdo - Agora à esquerda apenas no desktop */}
          <div className="flex flex-col justify-center space-y-3 order-2 lg:order-1">
            {/* Headline - Mantido igual */}
            <div className="space-y-0.5">
              <h2 className="text-sm md:text-base font-bold tracking-wider text-purple-800 animate-on-load opacity-0 translate-y-4 transition-all duration-500 ease-out mb-3">
                20 DE MARÇO - QUINTA-FEIRA - 8 DA NOITE
              </h2>
              <div className="inline-block animate-on-load opacity-0 translate-y-4 transition-all duration-500 ease-out">
                <span className="px-3 py-1 text-xs font-medium tracking-wider bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full shadow-md">Exclusivo</span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight animate-on-load opacity-0 translate-y-4 transition-all duration-700 ease-out bg-gradient-to-r from-purple-900 to-indigo-800 bg-clip-text text-transparent">
                Descubra o que o Ano-Novo Astrológico te reserva
              </h1>
            </div>
            
            {/* Subheadline - Mantido igual */}
            <p className="text-lg text-indigo-700 leading-relaxed animate-on-load opacity-0 translate-y-4 transition-all duration-700 delay-200 ease-out">
              Entenda o que precisa mudar para que você tenha um excelente ano
            </p>
            
            {/* Bullets - Mantido igual */}
            <div className="space-y-3 animate-on-load opacity-0 translate-y-4 transition-all duration-700 delay-300 ease-out">
              <div className="flex items-start space-x-3">
                <div className="min-w-6 h-6 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center shadow-md mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-sm md:text-base text-gray-700">Conheça os desafios e as coisas boas deste ano que está chegando</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="min-w-6 h-6 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center shadow-md mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-sm md:text-base text-gray-700">Descubra o que 2025 espera de mudanças em você</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="min-w-6 h-6 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center shadow-md mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-sm md:text-base text-gray-700">Evento gratuito <span className="text-xl">👇</span></p>
              </div>
            </div>
            
            {/* Formulário - Mantido igual */}
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 animate-on-load opacity-0 translate-y-4 transition-all duration-700 delay-200 ease-out shadow-xl ring-1 ring-purple-100">
              <div className="text-center">
                <h3 className="text-lg font-semibold text-purple-900">Inscreva-se agora mesmo</h3>
              </div>
              <RegistrationForm />
            </div>
          </div>
        </div>
        
        {/* Indicador de scroll */}
        <ScrollIndicator />
        
        {/* Seção numerada - Na versão mobile aparece abaixo */}
        <div className="lg:hidden mt-16 animate-on-load opacity-0 translate-y-4 transition-all duration-700 delay-400 ease-out">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-purple-800 to-indigo-700 bg-clip-text text-transparent">
              Para quem é esse evento?
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                  1
                </div>
              </div>
              <p className="text-gray-700">Para quem quer descobrir uma visão que vai além da astrologia</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                  2
                </div>
              </div>
              <p className="text-gray-700">Para quem está insatisfeita com a própria vida e quer mudar</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                  3
                </div>
              </div>
              <p className="text-gray-700">Para quem quer aproveitar ao máximo esse momento de renovação de ciclo</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                  4
                </div>
              </div>
              <p className="text-gray-700">Para quem busca uma conexão espiritual profunda e está aberto para o novo</p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-md ring-1 ring-purple-100 flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold shadow-md">
                  5
                </div>
              </div>
              <p className="text-gray-700">Para quem quer aprender novas práticas espirituais, rituais e novas formas de meditar</p>
            </div>
          </div>
        </div>
        
        {/* Seção da instrutora */}
        <div className="mt-20 animate-on-load opacity-0 translate-y-4 transition-all duration-700 delay-500 ease-out">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-purple-800 to-indigo-700 bg-clip-text text-transparent">
              Quem vai te conduzir nessa jornada?
            </h2>
          </div>
          
          {/* Versão mobile do card - não alterada */}
          <div className="md:hidden bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl ring-1 ring-purple-100">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
              {/* Avatar da instrutora */}
              <div className="md:col-span-1 flex justify-center">
                <div className="rounded-lg overflow-hidden shadow-lg ring-1 ring-purple-100">
                  <LazyImage 
                    src="/lovable-uploads/0e012d7d-c861-498c-b25d-13786870b502.png" 
                    alt="Maria Silvia Orlovas" 
                    className="w-full h-auto"
                  />
                </div>
              </div>
              
              {/* Bio da instrutora */}
              <div className="md:col-span-2 space-y-4 text-gray-700">
                <h3 className="text-xl md:text-2xl font-semibold bg-gradient-to-r from-purple-700 to-pink-600 bg-clip-text text-transparent">Maria Silvia Orlovas</h3>
                
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <p>Maria Silvia Orlovas, também conhecida como "MS", é casada, tem duas filhas e atua como comunicadora, escritora, terapeuta e educadora espiritual.</p>
                  
                  <p>Há muitos anos se dedica ao estudo das ciências ocultas e dos aspectos psicológicos que envolvem as pessoas.</p>
                  
                  <p>As suas pesquisas sobre mitologia, religiões antigas, arquétipos do Tarot e cura por meio das imagens do inconsciente a conduziram a um mergulho profundo no rico panteão hindu, na Wicca e no Sagrado Feminino. Logo demonstrou ser uma forte sensitiva com o dom de ver as vidas passadas das pessoas e começou a receber orientações dos seus mentores espirituais.</p>
                  
                  <p>Atualmente, ministra cursos, workshops e treinamentos online e presenciais voltados para o autoconhecimento. Também oferece uma mentoria, que inclui terapia de vidas passadas para quem deseja acelerar o aprendizado e a transformação pessoal.</p>
                  
                  <p>Além disso, tem 14 livros publicados, centenas de mensagens espirituais únicas, gravadas e documentadas, cerca de 11.000 alunos no mundo todo e mais de 900.000 seguidores nas redes sociais e no YouTube.</p>
                  
                  <p>Maria Silvia já mudou a vida de milhares de pessoas que passaram em terapia individual e em grupo, rituais e vivências transformadoras. Por mais de 25 anos, tem ensinado as pessoas a desenvolver um novo olhar e a criar uma conexão com os Mestres Ascensionados da Fraternidade Branca.</p>
                  
                  <p>Hoje, a sua maior alegria é ver o rosto dos seus seguidores e alunos se iluminando ao descobrir que a vida pode ser mais leve e feliz.</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Nova versão desktop do card - com imagem maior e layout diferente */}
          <div className="hidden md:block bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl ring-1 ring-purple-100">
            <div className="flex flex-col space-y-8">
              {/* Avatar da instrutora - maior e centralizado */}
              <div className="flex justify-center">
                <div className="w-full max-w-xl rounded-lg overflow-hidden shadow-lg ring-1 ring-purple-100">
                  <LazyImage 
                    src="/lovable-uploads/0e012d7d-c861-498c-b25d-13786870b502.png" 
                    alt="Maria Silvia Orlovas" 
                    className="w-full h-auto"
                  />
                </div>
              </div>
              
              {/* Bio da instrutora */}
              <div className="space-y-4 text-gray-700">
                <h3 className="text-2xl font-semibold bg-gradient-to-r from-purple-700 to-pink-600 bg-clip-text text-transparent text-center">Maria Silvia Orlovas</h3>
                
                <div className="space-y-4 text-gray-700 leading-relaxed max-w-4xl mx-auto">
                  <p>Maria Silvia Orlovas, também conhecida como "MS", é casada, tem duas filhas e atua como comunicadora, escritora, terapeuta e educadora espiritual.</p>
                  
                  <p>Há muitos anos se dedica ao estudo das ciências ocultas e dos aspectos psicológicos que envolvem as pessoas.</p>
                  
                  <p>As suas pesquisas sobre mitologia, religiões antigas, arquétipos do Tarot e cura por meio das imagens do inconsciente a conduziram a um mergulho profundo no rico panteão hindu, na Wicca e no Sagrado Feminino. Logo demonstrou ser uma forte sensitiva com o dom de ver as vidas passadas das pessoas e começou a receber orientações dos seus mentores espirituais.</p>
                  
                  <p>Atualmente, ministra cursos, workshops e treinamentos online e presenciais voltados para o autoconhecimento. Também oferece uma mentoria, que inclui terapia de vidas passadas para quem deseja acelerar o aprendizado e a transformação pessoal.</p>
                  
                  <p>Além disso, tem 14 livros publicados, centenas de mensagens espirituais únicas, gravadas e documentadas, cerca de 11.000 alunos no mundo todo e mais de 900.000 seguidores nas redes sociais e no YouTube.</p>
                  
                  <p>Maria Silvia já mudou a vida de milhares de pessoas que passaram em terapia individual e em grupo, rituais e vivências transformadoras. Por mais de 25 anos, tem ensinado as pessoas a desenvolver um novo olhar e a criar uma conexão com os Mestres Ascensionados da Fraternidade Branca.</p>
                  
                  <p>Hoje, a sua maior alegria é ver o rosto dos seus seguidores e alunos se iluminando ao descobrir que a vida pode ser mais leve e feliz.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-2 py-8 border-t border-purple-100 bg-gradient-to-b from-transparent to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center">
          <div className="text-sm text-purple-600 text-center">
            <p>&copy; 2025 Maria Silvia Orlovas</p>
            <p>Todos os direitos reservados</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
